import { Link } from "react-router-dom";

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-manrope font-bold text-hb-dark mb-4 border-b border-hb-border pb-3">
        {title}
      </h2>
      <div className="space-y-3 text-sm text-hb-text font-inter leading-relaxed">
        {children}
      </div>
    </div>
  );
}

export default function Datenschutz() {
  const resetConsent = () => {
    localStorage.removeItem("hb_cookie_consent");
    window.location.reload();
  };

  return (
    <div className="pt-20 md:pt-24 bg-white min-h-screen">
      <section className="section-gap border-b border-hb-border bg-hb-off-white">
        <div className="container-hb">
          <span className="label-text text-hb-wood block mb-4">Rechtliches</span>
          <h1 className="section-title max-w-2xl">Datenschutzerklärung</h1>
          <p className="text-sm text-hb-muted font-inter mt-3">Stand: März {new Date().getFullYear()}</p>
        </div>
      </section>

      <section className="section-gap">
        <div className="container-hb max-w-3xl space-y-10">

          <Section title="1. Verantwortlicher (Titolare del trattamento)">
            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (EU-DSGVO / Regolamento UE 2016/679)
              und des Italienischen Datenschutzgesetzes (D.Lgs. 196/2003, zuletzt geändert durch D.Lgs. 101/2018):
            </p>
            <p>
              <strong className="text-hb-dark">Hafner EC GmbH (Holzbuddy)</strong><br />
              Sinich-Bach-Str. 60 · I-39012 Meran (BZ) · Südtirol, Italien<br />
              Telefon: <a href="tel:+390473238030" className="text-hb-wood hover:underline">+39 0473 238 030</a><br />
              E-Mail: <a href="mailto:info@holzbuddy.team" className="text-hb-wood hover:underline">info@holzbuddy.team</a>
            </p>
            <p className="text-xs text-hb-muted">
              Für Anfragen zur Ausübung Ihrer Datenschutzrechte können Sie sich per E-Mail an uns wenden.
              Ein Datenschutzbeauftragter (DPO) ist für dieses Unternehmen gemäß Art. 37 DSGVO nicht verpflichtend bestellt,
              da keine der in Art. 37 Abs. 1 DSGVO genannten Voraussetzungen vorliegen.
            </p>
          </Section>

          <Section title="2. Welche Daten wir verarbeiten und warum">
            <p><strong className="text-hb-dark">a) Server-Logfiles (automatisch)</strong></p>
            <p>
              Beim Besuch dieser Website werden durch den Hosting-Server automatisch Informationen erfasst:
              Browsertyp und -version, Betriebssystem, Referrer-URL, IP-Adresse (anonymisiert), Datum und Uhrzeit.
              Diese Daten sind technisch erforderlich. <strong className="text-hb-dark">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an stabilem Betrieb).
              <strong className="text-hb-dark"> Speicherdauer:</strong> 30 Tage, dann automatische Löschung.
            </p>
            <p><strong className="text-hb-dark">b) Kontaktformular</strong></p>
            <p>
              Wenn Sie uns eine Anfrage senden, verarbeiten wir: Name, E-Mail-Adresse, Telefonnummer (optional),
              Projektart, Standort und Nachricht. Diese Daten werden ausschließlich für die Bearbeitung Ihrer Anfrage
              verwendet und nicht an Dritte weitergegeben.
              <strong className="text-hb-dark"> Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung).
              <strong className="text-hb-dark"> Speicherdauer:</strong> 3 Jahre nach Abschluss der Anfrage oder bis auf Anfrage gelöscht.
            </p>
          </Section>

          <Section title="3. Google Analytics 4">
            <p>
              Diese Website nutzt Google Analytics 4 (GA4) der Google LLC (1600 Amphitheatre Parkway,
              Mountain View, CA 94043, USA). Google Analytics wird
              <strong className="text-hb-dark"> nur nach Ihrer ausdrücklichen Einwilligung</strong> geladen.
            </p>
            <p>
              <strong className="text-hb-dark">Datenübermittlung in die USA:</strong> Google LLC ist unter dem
              EU-US Data Privacy Framework zertifiziert. Die Übermittlung in die USA erfolgt auf Grundlage
              eines Angemessenheitsbeschlusses der Europäischen Kommission (Art. 45 DSGVO) sowie
              zusätzlicher Standardvertragsklauseln (SCCs, Art. 46 DSGVO).
            </p>
            <p>
              <strong className="text-hb-dark">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung).
              Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen:
            </p>
            <button
              onClick={resetConsent}
              data-testid="reset-consent-btn"
              className="btn-secondary text-xs"
            >
              Cookie-Einstellungen zurücksetzen
            </button>
          </Section>

          <Section title="4. Cookies">
            <p>Diese Website verwendet folgende Cookies / lokale Speicherwerte:</p>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-hb-off-white">
                    <th className="text-left p-3 border border-hb-border font-semibold text-hb-dark">Name</th>
                    <th className="text-left p-3 border border-hb-border font-semibold text-hb-dark">Zweck</th>
                    <th className="text-left p-3 border border-hb-border font-semibold text-hb-dark">Anbieter</th>
                    <th className="text-left p-3 border border-hb-border font-semibold text-hb-dark">Laufzeit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-3 border border-hb-border font-mono">hb_cookie_consent</td>
                    <td className="p-3 border border-hb-border">Speichert Ihre Cookie-Entscheidung</td>
                    <td className="p-3 border border-hb-border">holzbuddy.team (localStorage)</td>
                    <td className="p-3 border border-hb-border">Dauerhaft (bis zur manuellen Zurücksetzung)</td>
                  </tr>
                  <tr className="bg-hb-off-white/50">
                    <td className="p-3 border border-hb-border font-mono">_ga, _ga_*</td>
                    <td className="p-3 border border-hb-border">Google Analytics – Nutzeridentifikation und Seitenanalyse</td>
                    <td className="p-3 border border-hb-border">Google LLC (USA)</td>
                    <td className="p-3 border border-hb-border">2 Jahre (nur nach Ihrer Zustimmung)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Section>

          <Section title="5. Ihre Rechte (Diritti dell'interessato)">
            <p>
              Gemäß DSGVO (Art. 15–21) und D.Lgs. 196/2003 haben Sie folgende Rechte gegenüber uns:
            </p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><strong className="text-hb-dark">Auskunft</strong> (Art. 15 DSGVO) – Welche Daten wir von Ihnen speichern</li>
              <li><strong className="text-hb-dark">Berichtigung</strong> (Art. 16 DSGVO) – Korrektur unrichtiger Daten</li>
              <li><strong className="text-hb-dark">Löschung</strong> (Art. 17 DSGVO / "Recht auf Vergessenwerden")</li>
              <li><strong className="text-hb-dark">Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
              <li><strong className="text-hb-dark">Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
              <li><strong className="text-hb-dark">Widerspruch</strong> (Art. 21 DSGVO)</li>
              <li><strong className="text-hb-dark">Widerruf einer Einwilligung</strong> (Art. 7 Abs. 3 DSGVO)</li>
            </ul>
            <p>
              Zur Ausübung Ihrer Rechte wenden Sie sich schriftlich an:{" "}
              <a href="mailto:info@holzbuddy.team" className="text-hb-wood hover:underline">info@holzbuddy.team</a>
            </p>
            <p>
              Sie haben außerdem das Recht, bei der zuständigen Datenschutz-Aufsichtsbehörde Beschwerde einzulegen.
              In Italien ist dies der:
            </p>
            <p className="pl-3 border-l-2 border-hb-yellow/30">
              <strong className="text-hb-dark">Garante per la protezione dei dati personali</strong><br />
              Piazza Venezia 11 · I-00187 Roma<br />
              <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-hb-wood hover:underline">www.garanteprivacy.it</a>
            </p>
          </Section>

          <Section title="6. Datensicherheit">
            <p>
              Diese Website nutzt eine SSL/TLS-Verschlüsselung (HTTPS) für die sichere Übertragung aller Daten.
              Unsere Server-Infrastruktur ist technisch und organisatorisch gemäß Art. 32 DSGVO gesichert.
            </p>
          </Section>

          <Section title="7. Aktualität dieser Erklärung">
            <p>
              Diese Datenschutzerklärung wird regelmäßig aktualisiert. Der aktuelle Stand ist oben angegeben.
              Bei wesentlichen Änderungen informieren wir Sie in geeigneter Weise.
            </p>
          </Section>

          <div className="pt-6 border-t border-hb-border">
            <Link to="/impressum" className="btn-link text-sm">
              Zum Impressum →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
